export default __webpack_public_path__ + "static/media/email.1bc35491.svg";